// Components
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { v4 as uuid } from 'uuid';

// Reducers selectors/actions
import { setListId } from '@core/reducers/eventingSlice';
import SponsoredResultsPopover from '@core/shared/components/SponsoredResultsPopover';
import { type VoyagerResult } from '@core/ts/results';

import { NoResults } from '../NoResults';
import DefaultExactMatches from './DefaultExactMatches';
import ExactMatches from './ExactMatches';
import styles from './Results.module.css';

type Props = {
  results: VoyagerResult[];
  relatedResults: VoyagerResult[];
  uniqueMatches: VoyagerResult[];
  hasEmbeddedRecommenderResults?: boolean;
};

const Results = ({ results, relatedResults, uniqueMatches, hasEmbeddedRecommenderResults }: Props) => {
  const [needListIdChange, setNeedListIdChange] = useState(false);

  // Action Dispatcher
  const dispatch = useDispatch();

  // listId is used for eventing. it should change every time that algolia gives us a new results set
  // When the searchState changes we set the `needListIdUpdate` to true
  // so that the next time that `searchResults` change, we change the listId
  useEffect(() => {
    setNeedListIdChange(true);
  }, []);

  // Updating the listId only if the `needListIdChange` flag is set to true
  useEffect(() => {
    if (needListIdChange) {
      dispatch(setListId(uuid()));
      setNeedListIdChange(false);
    }
  }, [results]);

  return (
    <>
      {/* if no exact, related or unique matches, and app is not in loading state */}
      {!hasEmbeddedRecommenderResults &&
      results?.length === 0 &&
      uniqueMatches?.length === 0 &&
      relatedResults?.length === 0 ? (
        <>
          {/* no results
if no hits, and app is not in loading state */}
          <NoResults />
        </>
      ) : (
        <>
          {/* Results  */}

          <div className={styles.sponsoredResultsRow}>{results?.length > 0 && <SponsoredResultsPopover />}</div>
          <ExactMatches results={results} uniqueMatches={uniqueMatches} ExactMatchesComponent={DefaultExactMatches} />
        </>
      )}
    </>
  );
};

export { Results };
